'use strict';

const adformConstants = require('../adformConstants');
const { removeAdformPlaceholder } = require('../common/adformHelperFunctions');
const adformElementEvents = require('../adformElementEvents');
const { generateBannerHtml } = require('./adformContentBuilderHelpers');

const SLIDE_CLASS = 'swiper-slide';

/**
 * Builds one slide element per bid, ready to be inserted into a slider.
 * @param {Object[]} bids - adform bids
 * @return {Element[]} - slide elements
 */
function buildBidSlides(bids) {
    const slides = [];
    bids.forEach((bid, index) => {
        const isImgLoadingLazy = index !== 0;
        const bidHtml = generateBannerHtml(bid, isImgLoadingLazy);
        if (!bidHtml) {
            return;
        }

        const slide = document.createElement('div');
        slide.classList.add(SLIDE_CLASS, 'apply-slide-cls-fix');
        slide.innerHTML = bidHtml;

        const bidImg = slide.querySelector(`.${adformConstants.BID_IMG_JS_CLASS}`);
        bidImg.addEventListener('load', () => {
            adformElementEvents.initClickEvent(slide, bid);
            adformElementEvents.initInViewportObserver(slide, bid);
        });

        slides.push(slide);
    });

    return slides;
}

/**
 * Inserts ad slides at the front of a slider - via the live Swiper instance if it already exists,
 * otherwise as raw DOM nodes (safe pre-init, since Swiper hasn't scanned the wrapper's children yet).
 * @param {Element} slider - slider element
 * @param {Element[]} slides - slide elements to insert
 * @return {boolean} - if any slide was inserted
 */
function insertBidSlides(slider, slides) {
    if (!slides.length) {
        return false;
    }

    const sliderSwiperInstance = slider.swiper;
    if (sliderSwiperInstance) {
        sliderSwiperInstance.prependSlide(slides);
    } else {
        const swiperWrapper = slider.querySelector('.swiper-wrapper');
        let previousSlide = null;
        slides.forEach((slide, index) => {
            if (index === 0) {
                swiperWrapper.prepend(slide);
            } else {
                previousSlide.after(slide);
            }
            previousSlide = slide;
        });
    }

    return true;
}

/**
 * Reveals a slider by removing the loading placeholder and snapping to the first slide
 * (whatever autoplay did underneath the placeholder while pending doesn't matter - this is the user's first look).
 * @param {Element} slider - slider element
 */
function revealSlider(slider) {
    removeAdformPlaceholder(slider);

    // no explicit update() here - insertBidSlides()'s prependSlide() already ran one when a slide was inserted,
    // and nothing needs recalculating on the no-bids path since no slide changed
    const sliderSwiperInstance = slider.swiper;
    if (sliderSwiperInstance) {
        sliderSwiperInstance.slideTo(0, 0, false);
    }
}

module.exports = {
    buildBidSlides: buildBidSlides,
    insertBidSlides: insertBidSlides,
    revealSlider: revealSlider
};
